<div class="mobile-breadcrumb-bar" *ngIf="loginService.isLoggedIn() && !builderService.getTour() && (parts().length > 0 || section())">
  <button class="mobile-breadcrumb-menu-btn" (click)="openSidebar($event)">
    <span class="material-icons">menu</span>
  </button>
  <span class="mobile-breadcrumb-text">
    <a *ngIf="sectionPath(); else staticSection" [routerLink]="sectionPath()" class="breadcrumb-link section_text">{{ section() }}</a>
    <ng-template #staticSection><span class="section_text">{{ section() }}</span></ng-template>
    <ng-container *ngFor="let part of parts(); let last = last">
      <span class="breadcrumb-separator"> /</span>
      <a [routerLink]="part.path" class="breadcrumb-link" [class.active]="last">{{ part.label }}</a>
    </ng-container>
  </span>
  <button *ngIf="builderService.selectedProject" mat-icon-button [routerLink]="['versions']" class="versionsBtn stacksBtn lightBtn blue breadcrumb-versions-btn">
    <img src="assets/icons/history.svg" alt="history">
  </button>
</div>
